import { createFileRoute } from '@tanstack/react-router'
import FeatureFlags from '../components/feature-flags/FeatureFlags'

export const Route = createFileRoute('/_a/featureFlags')({
  component: FeatureFlags,
})
